import { defineComponent as _defineComponent } from 'vue'
import BaseDialog from "@/components/base-dialog.vue";
import CrownIcon from "@/assets/icons/svg/crown.icon.svg";


export default /*#__PURE__*/_defineComponent({
  __name: 'lecturer-you-are-meeting-host-dialog',
  props: {
    isVisible: { type: Boolean },
    onClose: null
  },
  emits: ["on-continue"],
  setup(__props: any, { emit }: { emit: ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (e: "on-continue"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  isVisible: boolean;
  onClose: () => void;
}





const closeDialog = () => {
  props.onClose();
};

const onContinue = () => {
  emit("on-continue");
  closeDialog();
};

return { __sfc: true,props, emit, closeDialog, onContinue, BaseDialog, CrownIcon }
}

})